import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsbSocket = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 52,
	height: 92,
	viewBox: "0 0 52 92",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 15C6 24.333 5.622 30 5 30C4.45 30 3.1 30.9 2 32C0.14 33.86 0 35.333 0 53.05C0 73.8 0.590985 76.581 5.47198 78.805C6.91398 79.462 10.323 80 13.047 80H18V86C18 91.333 18.222 92 20 92C21.778 92 22 91.333 22 86V80H26H30V86C30 91.333 30.222 92 32 92C33.778 92 34 91.333 34 86V80H38.953C41.677 80 45.086 79.462 46.528 78.805C51.409 76.581 52 73.8 52 53.05C52 35.333 51.86 33.86 50 32C48.9 30.9 47.55 30 47 30C46.378 30 46 24.333 46 15V0H26H6V15ZM42 17V30H26H10V17V4H26H42V17ZM14 17C14 19.833 14.222 20 18 20C21.778 20 22 19.833 22 17C22 14.167 21.778 14 18 14C14.222 14 14 14.167 14 17ZM30 17C30 19.833 30.222 20 34 20C37.778 20 38 19.833 38 17C38 14.167 37.778 14 34 14C30.222 14 30 14.167 30 17ZM47.772 53.228C48.129 77.832 49.88 76 26 76C2.247 76 4 77.779 4 53.667C4 43.583 4.309 35.025 4.686 34.647C5.063 34.27 14.851 34.083 26.436 34.231L47.5 34.5L47.772 53.228Z",
		fill: "black"
	})]
});
const ForwardRef = forwardRef(SvgUsbSocket);
export { ForwardRef as ReactComponent };
